var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "post-preview-component",
      class: { shareable: _vm.shareable }
    },
    [
      _vm.post.follow_frequency ? _c("FollowFrequency") : _vm._e(),
      _vm._v(" "),
      !_vm.post.follow_frequency
        ? _c(
            "div",
            {
              staticClass: "discussion-post-card",
              class: { full__attachment: _vm.isFullAttachment }
            },
            [
              _c("div", { staticClass: "discussion-post-header" }, [
                _c("a", { staticClass: "discussion-user-info" }, [
                  _c("img", {
                    staticClass: "discussion-avatar",
                    attrs: { src: _vm.post.owner.avatar, alt: "user" },
                    on: { click: _vm.goToOwnerProfile }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "discussion-user-meta" }, [
                    _c("div", { staticClass: "discussion-user-name" }, [
                      _c("a", { on: { click: _vm.goToOwnerProfile } }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.post.owner.first_name) +
                            " " +
                            _vm._s(_vm.post.owner.last_name) +
                            " \n                        "
                        )
                      ]),
                      _vm._v(" "),
                      _vm.group && !_vm.$route.path.startsWith("/groups")
                        ? _c("span", { staticClass: "group_link" }, [
                            _vm._v(
                              " \n                            to \n                            "
                            ),
                            _c(
                              "a",
                              { attrs: { href: "/groups/" + _vm.group.id } },
                              [
                                _vm._v(
                                  _vm._s(_vm.group.group_name) +
                                    "\n                            "
                                )
                              ]
                            )
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "discussion-post-date" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.moment(_vm.post.created_at).fromNow()) +
                          "\n                        "
                      ),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "discussion-lock-icon",
                        attrs: {
                          title:
                            _vm.post.privacy.charAt(0).toUpperCase() +
                            _vm.post.privacy.slice(1),
                          src:
                            _vm.postFromGroup || _vm.post.privacy === "friends"
                              ? require("@assets/imgs/events/privacy-connections.png")
                              : _vm.post.privacy === "friends_group"
                              ? require("@assets/imgs/events/privacy-secret.png")
                              : require("@assets/imgs/events/privacy-public.png")
                        }
                      })
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "click-outside",
                        rawName: "v-click-outside",
                        value: _vm.hideDropdown,
                        expression: "hideDropdown"
                      }
                    ],
                    staticClass: "discussion-post-options"
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn__reset fs__20 margin-l__25",
                        on: { click: _vm.toggleDropdown }
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@assets/imgs/events/dots-icon.svg")
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _vm.showDropdown
                      ? _c("DropDown", {
                          attrs: { items: _vm.dropdownContent }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  ref: "post-" + _vm.post.id,
                  staticClass: "discussion-post-content"
                },
                [
                  _c("a", { staticClass: "content_link" }, [
                    _vm.post.description
                      ? _c("div", [
                          _c("p", {
                            directives: [
                              { name: "linkified", rawName: "v-linkified" }
                            ],
                            staticClass: "discussion-post-text",
                            domProps: { innerHTML: _vm._s(_vm.postText) }
                          })
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _vm.post.description.length > 490
                    ? _c("span", [
                        _vm._v("... \n                "),
                        _c(
                          "a",
                          {
                            staticClass: "about-read-more",
                            attrs: { href: "#" },
                            on: { click: _vm.toggleShowMore }
                          },
                          [
                            _vm._v(
                              " \n                    " +
                                _vm._s(_vm.showMoreText) +
                                " \n                "
                            )
                          ]
                        )
                      ])
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { class: _vm.containerClass },
                [
                  _vm.post.share_post
                    ? _c("PostPreview", {
                        attrs: {
                          shareable: true,
                          post: _vm.post.share_post,
                          user: _vm.user
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.post.share_post
                    ? _c(
                        "div",
                        [
                          _vm.textEmbed
                            ? _c("TextEmbed", {
                                attrs: { embed_url_info: _vm.textEmbed }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("ParsedLink", { attrs: { content: _vm.post } }),
                          _vm._v(" "),
                          (_vm.post.attachment_order_type.length &&
                            !_vm.isFullAttachment) ||
                          _vm.post.attachment_order_type.length === 1
                            ? _c(
                                "div",
                                { staticClass: "feedAttachment" },
                                [
                                  _vm.showAttachCount
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "feedAttachment__count",
                                          on: { click: _vm.goToPost }
                                        },
                                        [
                                          _vm._v(
                                            "\n                        " +
                                              _vm._s(
                                                _vm.$t("FEED.ATTACH_COUNT", {
                                                  count: _vm.attachCount
                                                })
                                              ) +
                                              "\n                    "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("FeedAttachment", {
                                    attrs: {
                                      content: _vm.post,
                                      "open-post": true
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isFullAttachment &&
                          _vm.post.attachment_order_type.length !== 1
                            ? _c(
                                "div",
                                [
                                  _c("AttachmentList", {
                                    attrs: { post_id: _vm.post.id }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              !_vm.shareable
                ? _c("div", { staticClass: "discussion-post-footer" }, [
                    _c(
                      "button",
                      {
                        staticClass: "discussion-footer-btn",
                        on: { click: _vm.toggleComments }
                      },
                      [
                        _c("img", {
                          staticClass: "discussion-btn-icon",
                          attrs: {
                            src: require("@assets/imgs/events/comment.svg"),
                            alt: "comment"
                          }
                        }),
                        _vm._v(" "),
                        _vm._v(
                          "\n                Comment (" +
                            _vm._s(_vm.post.comment_count) +
                            ")\n            "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "discussion-footer-btn",
                        on: { click: _vm.showShareModal }
                      },
                      [
                        _c("img", {
                          staticClass: "discussion-btn-icon",
                          attrs: {
                            src: require("@assets/imgs/events/export.svg"),
                            alt: "share"
                          }
                        }),
                        _vm._v(
                          "\n                Share (" +
                            _vm._s(_vm.post.shares_count) +
                            ")\n            "
                        )
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("CommentsList", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showComments,
                    expression: "showComments"
                  }
                ],
                attrs: {
                  "load-comments": _vm.isFullAttachment,
                  "pinned-comment": _vm.pinnedComment,
                  post: _vm.post,
                  user: _vm.user
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }